import { useGetAgencyQuery } from '@/modules/agencies/api/agenciesApi'
import { useAgencyEditForm } from '@/modules/agencies/hooks/useAgencyEditForm'
import { useAgencyStatusActions } from '@/modules/agencies/hooks/useAgencyStatusActions'
import { getAgencyStatusAction } from '@/modules/agencies/utils/agencyStatusAction'
import { useAppRoute } from '@/hooks/useAppRoute'
import { getAuthErrorMessage } from '@/utils/getAuthErrorMessage'

export function useAgencyDetail() {
  const { agencyId, navigateToAgencies } = useAppRoute()
  const { data, isLoading, isError, error } = useGetAgencyQuery(agencyId ?? '', {
    skip: !agencyId,
  })
  const { openEdit } = useAgencyEditForm()
  const { openStatusConfirm, isPending: isStatusPending } = useAgencyStatusActions()

  return {
    agencyId,
    agency: data ?? null,
    isLoading: Boolean(agencyId) && isLoading && !data,
    isError,
    errorMessage: isError ? getAuthErrorMessage(error) : null,
    isMissingId: !agencyId,
    statusAction: data ? getAgencyStatusAction(data.status) : null,
    isStatusPending,
    onBack: navigateToAgencies,
    onEdit: () => {
      if (data) {
        openEdit(data)
      }
    },
    onStatusAction: () => {
      if (data) {
        openStatusConfirm(data)
      }
    },
  }
}
